// src/components/Layout/index.tsx
import { FC } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Layout as AntLayout } from 'antd';
import Sidebar from './Sidebar';
import Header from './Header';
import MobileHeader from './MobileHeader';
import AIChatButton from '@/components/AIChatButton';
import HelpButton from '@/components/HelpButton';
import { PATHS } from '@/router/paths';
import styles from './index.module.scss';

const { Content } = AntLayout;

const Layout: FC = () => {
  const location = useLocation();
  const hideHelpButton = location.pathname === PATHS.interviewSimulation.session;

  return (
    <AntLayout className={styles.layout}>
      <Sidebar />
      <MobileHeader />
      <AntLayout className={styles.mainLayout}>
        <Header />
        <Content className={styles.content}>
          <Outlet />
        </Content>
      </AntLayout>
      {!hideHelpButton && <AIChatButton />}
      {!hideHelpButton && <HelpButton />}
    </AntLayout>
  );
};

export default Layout;
